module.exports = __webpack_public_path__ + "img/cognition.741b97bf.svg";